import { AppRouteProps } from "@bsm/component";
import { UserStudentFamilyListContainer } from "./container/UserStudentFamilyListContainer";
import { UserStudentFamilyCreateRoute } from "./views/create/UserStudentFamilyCreateRoute";
import { UserStudentFamilyDetailsRoute } from "./views/details/UserStudentFamilyDetailsRoute";

export const UserStudentFamilyRoutes: Array<AppRouteProps> = [
    {
        path: 'family',
        element: <UserStudentFamilyListContainer />,
        children: [
            ...UserStudentFamilyCreateRoute,
            ...UserStudentFamilyDetailsRoute
        ]
    }
]